import { EventDto, ReservationRequestDto } from "@/api/generated/generatedTypes";

export interface ExistingEventWithStaging extends EventDto {
  stagedRequests: ReservationRequestDto[];
}

export interface AttendeeItemProps {
  request: ReservationRequestDto;
  eventStartTime: string;
  eventLocationName: string;
  isStaging: boolean;
  onRemove?: (requestId: number) => void;
  onChangeRequest?: (requestId: number) => void;
  onCancel?: (requestId: number) => void;
}

export interface AttendeesListProps {
  attendees: ReservationRequestDto[];
  stagedRequests: ReservationRequestDto[];
  eventStartTime: string;
  eventLocationName: string;
  onRemoveStaged: (requestId: number) => void;
  onChangeRequest: (requestId: number) => void;
  onCancel: (requestId: number) => void;
}

export interface EventVenue {
  id: number;
  name: string;
  address: string;
  locationId?: number | null;
  locationName?: string | null;
  type: "RESTAURANT" | "AFTER_PARTY";
}

export interface ExistingEventCardProps {
  event: ExistingEventWithStaging;
  venues: EventVenue[];
  isSelected: boolean;
  onSelect: () => void;
  onRemoveStaged: (requestId: number) => void;
  onSave: () => void;
  onSaveVenue: (restaurantId: number | null, afterPartyId: number | null) => void;
  onConfirm: () => void;
  onChangeRequest: (requestId: number) => void;
  onCancel: (requestId: number) => void;
}

export const formatTime = (time: Date | string): string => {
  const timeString = typeof time === "string" ? time : time.toISOString();
  return new Date(timeString).toLocaleString();
};
